// Helpers to embed video URLs from popular providers (YouTube, Vimeo) or to
// detect direct video files (uploaded mp4/webm/mov) for use in <video> tags.

const YT_RE = /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{6,})/i;
const VIMEO_RE = /vimeo\.com\/(?:video\/)?(\d{6,})/i;

const RAW_VIDEO_EXT = /\.(mp4|webm|mov|m4v)(\?.*)?$/i;

export const parseVideoUrl = (url) => {
  if (!url) return null;
  const m1 = url.match(YT_RE);
  if (m1) {
    return { kind: "iframe", embed: `https://www.youtube.com/embed/${m1[1]}?rel=0&modestbranding=1`, provider: "youtube" };
  }
  const m2 = url.match(VIMEO_RE);
  if (m2) {
    return { kind: "iframe", embed: `https://player.vimeo.com/video/${m2[1]}`, provider: "vimeo" };
  }
  if (url.startsWith("/api/uploads/") || RAW_VIDEO_EXT.test(url)) {
    const src = url.startsWith("/api/")
      ? `${process.env.REACT_APP_BACKEND_URL || ""}${url}`
      : url;
    return { kind: "file", src, provider: "file" };
  }
  return null;
};
